import moment from "moment";
import sv from "date-fns/locale/sv";
import { format, parseISO } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import DateInput, {
  ReactDatePickerCustomHeaderProps,
  registerLocale
} from "react-datepicker";
import { TextField } from "@material-ui/core";
import { CalendarToday } from "@material-ui/icons";
import { withStyles } from "@material-ui/styles";
import { DatePickerProps } from "./date-picker-props";
import { DatePickerCustomHeader } from "./date-picker-customer-header";
import { DatePickerCustomContainer } from "./date-picker-customer-container";
import { Color } from "../../../theme/color";

registerLocale("sv", sv);

export function DatePicker(props: DatePickerProps) {
  const dateFormat = props.dateFormat || "YYYY-MM-DD";

  const minDate = props.DatePickerProps?.minDate || new Date(1900, 0, 1);
  const maxDate = props.DatePickerProps?.maxDate || new Date(2040, 11, 31);

  const value = props.value ? moment(props.value).format(dateFormat) : "";

  const customInput = (
    <TextField
      autoComplete={props.autoComplete}
      autoFocus={props.autoFocus}
      fullWidth={props.fullWidth}
      multiline={false}
      name={props.name}
      error={props.error}
      label={props.label}
      value={value}
      id={props.id}
      placeholder={props.placeholder}
      helperText={props.helperText}
      required={props.required}
      InputProps={{
        readOnly: true,
        startAdornment: <CalendarToday fontSize="small" color="disabled" />,
        ...props.inputProps
      }}
    />
  );

  return (
    <>
      <GlobalCss />

      <DateInput
        toggleCalendarOnIconClick
        showIcon={false}
        selected={props.value}
        onChange={(v, e) => props.onChange(toUTCDate(v), e)}
        dateFormat={"yyyy-MM-dd"}
        minDate={minDate}
        maxDate={maxDate}
        calendarContainer={DatePickerCustomContainer}
        formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 3)}
        locale="sv"
        renderCustomHeader={(params: ReactDatePickerCustomHeaderProps) => {
          return (
            <DatePickerCustomHeader {...params} minDate={minDate} maxDate={maxDate} />
          );
        }}
        isClearable={props.isClearable ?? true}
        customInput={customInput}
        name={props.name}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        showWeekNumbers
        {...props.DatePickerProps}
      />
    </>
  );
}

const toUTCDate = (date: Date | null) => {
  if (!date) return null;
  const utcString = format(date, "yyyy-MM-dd'T'HH:mm:ss'Z'");
  return parseISO(utcString);
};

const GlobalCss = withStyles({
  "@global": {
    ".react-datepicker-popper": {
      zIndex: 2
    },
    ".react-datepicker__header": {
      borderBottom: "none !important",
      backgroundColor: `${Color.White} !important`,
      padding: "0 !important",
      border: "none !important",
      borderRadius: "0.3rem !important"
    },
    ".react-datepicker__day--keyboard-selected": {
      backgroundColor: `${Color.PrimaryMain} !important`,
      color: `${Color.White} !important`
    },
    " .react-datepicker__day--selected": {
      backgroundColor: `${Color.PrimaryMain} !important`,
      color: `${Color.White} !important`
    },
    ".react-datepicker__day-name": {
      textTransform: "capitalize"
    },
    ".react-datepicker__week-number--selected": {
      backgroundColor: `transparent !important`,
      color: `${Color.PrimaryMain} !important`,
      fontWeight: "bold"
    },
    ".react-datepicker__week-number--keyboard-selected": {
      backgroundColor: `transparent !important`,
      color: `${Color.PrimaryMain} !important`,
      fontWeight: "bold"
    },
    ".react-datepicker__close-icon::after": {
      content: "'✕'",
      fontSize: "12px",
      color: `${Color.DetailsInput}`,
      position: "absolute",
      bottom: "12px",
      right: "12px",
      backgroundColor: "transparent"
    }
  }
})(() => null);
